import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/Pages.css';

import heroImage from '../assets/images/aboutHero.png';
import expertise1 from '../assets/images/about1.jpg';
import expertise2 from '../assets/images/about2.jpg';

const AboutUs = ({ onNavigate }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="service-page">
      <Header onNavigate={onNavigate} />

      {/* PAGE TITLE */}
      <section className="page-title" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="overlay">
          <div className="container">
            <h1>About Us</h1>
            <p>Building India's Critical Infrastructure</p>
          </div>
        </div>
      </section>

      {/* SECTION 1: OUR EXPERTISE - IMAGE LEFT + TEXT RIGHT */}
      <section style={{ padding: '80px 20px', background: '#fff' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '50px', alignItems: 'center' }}>
          
          {/* IMAGE LEFT */}
          <div style={{ 
            overflow: 'hidden', 
            borderRadius: '12px', 
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            aspectRatio: '4/3'
          }}>
            <img 
              src={expertise1} 
              alt="Our Expertise"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>

          {/* TEXT RIGHT */}
          <div>
            <h2 style={{ fontSize: '32px', color: '#0066cc', fontWeight: 'bold', marginBottom: '10px' }}>
              Our Expertise
            </h2>
            <h3 style={{ fontSize: '24px', color: '#1a2b4a', fontWeight: 'bold', marginBottom: '25px' }}>
              Building National Assets
            </h3>
            <p style={{ fontSize: '16px', color: '#555', lineHeight: '1.8', marginBottom: '20px', textAlign: 'justify' }}>
              Max Infra specializes in executing large and complex projects across multiple sectors including Railways, Irrigation, Highways, Water Supply, Bridges, and Hydro Projects. With cutting-edge technology and a dedicated team of 5000+ employees, we deliver world-class infrastructure solutions.
            </p>
            <button style={{ 
              background: '#0066cc', 
              color: '#fff', 
              border: 'none', 
              padding: '12px 30px', 
              fontSize: '16px', 
              fontWeight: 'bold',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#004499';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#0066cc';
              e.target.style.transform = 'translateY(0)';
            }}>
              Explore Services
            </button>
          </div>
        </div>
      </section>

      {/* SECTION 2: ABOUT MAX INFRA - IMAGE LEFT + TEXT RIGHT */}
      <section style={{ padding: '80px 20px', background: '#f9f9f9' }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto', display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '50px', alignItems: 'center' }}>
          
          {/* IMAGE LEFT */}
          <div style={{ 
            overflow: 'hidden', 
            borderRadius: '12px', 
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            aspectRatio: '4/3'
          }}>
            <img 
              src={expertise2} 
              alt="About MaxInfra"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>

          {/* TEXT RIGHT */}
          <div>
            <h2 style={{ fontSize: '32px', color: '#0066cc', fontWeight: 'bold', marginBottom: '10px' }}>
              About MaxInfra
            </h2>
            <h3 style={{ fontSize: '24px', color: '#1a2b4a', fontWeight: 'bold', marginBottom: '25px' }}>
              Thriving on Core Competence
            </h3>
            <p style={{ fontSize: '16px', color: '#555', lineHeight: '1.8', marginBottom: '20px', textAlign: 'justify' }}>
              MAX INFRA (I) PRIVATE LIMITED, a flourishing brand in Civil Engineering, Design and Construction business with a set mark of three decades well established, celebrated and proven record in India. We have considerable expertise in executing large and complex projects exclusively diversified in the field of Tunnels such as Railways, Irrigation and Highways. Besides Tunnels, our expertise is spread across sectors like Water Supply Projects, Large Canals, Reservoirs, Barrages, Bridges, Lift Irrigation schemes, Hydro Projects and Mining.
            </p>
            <p style={{ fontSize: '16px', color: '#555', lineHeight: '1.8', marginBottom: '25px', textAlign: 'justify' }}>
              Our services are varied. We adhere to excellent, dedicated and committed services and solutions with superior quality standards for our esteemed clients. We are way beyond the expectation of our clients and take pride in delivering projects within stipulated timelines.
            </p>
            <button style={{ 
              background: '#0066cc', 
              color: '#fff', 
              border: 'none', 
              padding: '12px 30px', 
              fontSize: '16px', 
              fontWeight: 'bold',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.target.style.background = '#004499';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.target.style.background = '#0066cc';
              e.target.style.transform = 'translateY(0)';
            }}>
              Learn More
            </button>
          </div>
        </div>
      </section>

      <Footer />

      {/* RESPONSIVE */}
      <style>{`
        @media (max-width: 1024px) {
          .about-section {
            grid-template-columns: 1fr !important;
            gap: 30px !important;
          }
        }
        @media (max-width: 768px) {
          .about-section {
            grid-template-columns: 1fr !important;
            gap: 25px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default AboutUs;